export const routes = {
    transactions: '/',
    consumers: '/consumers',
    admins: '/admins',
    admin: '/admins/:id',
    consumer: '/consumers/:id',
    logs: '/logs',
    tickets: '/tickets',
    signin: '/sign-in',
    forgot: '/forgot-password',
    not_found: '/404',
    loyalty: '/loyalty',
    limits: '/limits',
    signup: '/sign-up',
    agreements: '/agreements',
    agreement: '/agreements/:id',
    products: '/products',
    external_payments: '/external-payments',
    gift_cards: '/gift-cards'
};
